/**
 * exportPng.ts — serializa o SVG do preview em PNG via Canvas.
 * Fluxo: SVG string → data URL → <img> → canvas → toBlob → download.
 */
export function svgToString(svg: SVGSVGElement): string {
  const clone = svg.cloneNode(true) as SVGSVGElement;
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  return new XMLSerializer().serializeToString(clone);
}

export async function exportSvgToPngBlob(svg: SVGSVGElement, scale = 2): Promise<Blob> {
  const str = svgToString(svg);
  const vb = svg.viewBox.baseVal;
  const w = (vb && vb.width) || svg.clientWidth || 400;
  const h = (vb && vb.height) || svg.clientHeight || 480;
  const url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(str);

  const img = new Image();
  img.decoding = 'sync';
  await new Promise<void>((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error('falha ao carregar SVG para exportação'));
    img.src = url;
  });

  const canvas = document.createElement('canvas');
  canvas.width = Math.round(w * scale);
  canvas.height = Math.round(h * scale);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas 2d indisponível');
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('toBlob vazio'))), 'image/png');
  });
}

export async function downloadPng(svg: SVGSVGElement, filename = 'camisa-toca.png'): Promise<void> {
  const blob = await exportSvgToPngBlob(svg);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
